;
( function( $, window, document, undefined )
{
    'use strict';

    var BrowseTopics = function( element, options )
    {
        this.els             = options.els;
        this.els.$boardsList = $( '#boards-list' );
        this.l10n            = $.parseJSON( this.els.$boardsList.find( '.l10n-content' ).html() );

        this.showMore();
        this.support();
    };

    BrowseTopics.prototype = {

        support: function () {
            var that = this
              , $mod = $('#pdc6-modal-support')

            $('#pdc6-modal-mask-support').click(function () {
                that.els.$body.removeClass('with-modal')
            })

            $mod.find('.pdc6-modal-close').click(function (e) {
                e.preventDefault()

                that.els.$body.removeClass('with-modal')
            })

            $('.boards').find('a:not([data-support=""]):not(.more)').click(function (e) {
                e.preventDefault()

                that.els.$body.addClass('with-modal')

                var urls = {
                    chat: $(this).attr('href'),
                    help: $(this).data('support')
                }

                $mod.find('.chat').attr('href', urls.chat)
                $mod.find('.support').attr('href', urls.help)
            })
        },

        showMore : function()
        {
            var that = this;

            this.els.$boardsList.on( 'click', '.more', function( e )
            {
                e && e.preventDefault();

                var $this  = $( this ).toggleClass( 'active' )
                  , active = $this.hasClass( 'active' );

                $this.html( that.l10n[ active ? 'showLess' : 'showAll' ] + '<svg id="" class="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="28.75" height="20.06" viewBox="0 0 14.375 10.03"> <path d="M7.253,4.589 L11.586,0.047 L14.363,2.777 L7.253,10.016 L-0.002,2.628 L2.582,-0.004 L7.253,4.589 Z" class="cls-1"></path> </svg>' );
                $this.closest( 'ul' ).find( '.hidden' )[ active ? 'addClass' : 'removeClass' ]( 'extra' );
            } );
        }

    };

    $.fn.BrowseTopics = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'BrowseTopics' );

        if( !instance )
        {
            instance = new BrowseTopics( this, options );
            $item.data( 'BrowseTopics', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );
